import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Landing from "@/pages/Landing";
import Auth from "@/pages/Auth";
import Clubs from "@/pages/Clubs";
import ClubDetail from "@/pages/ClubDetail";
import CustomerDashboard from "@/pages/CustomerDashboard";
import OwnerDashboard from "@/pages/OwnerDashboard";
import AdminDashboard from "@/pages/AdminDashboard";
import MembershipCard from "@/pages/MembershipCard";
import VerifyPage from "@/pages/VerifyPage";
import LegalPage from "@/pages/LegalPage";
import PaymentReturn from "@/pages/PaymentReturn";
import RevenueCalculator from "@/pages/RevenueCalculator";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import OwnerBlog from "@/pages/OwnerBlog";
import ChatWidget from "@/components/ChatWidget";

function Protected({ children, role }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="p-10 font-heading font-bold text-xl">Loading...</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (role && user.role !== role) return <Navigate to={user.role === "owner" ? "/owner" : user.role === "admin" ? "/admin" : "/dashboard"} replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <Toaster position="top-center" richColors />
        <ChatWidget />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Auth mode="login" />} />
            <Route path="/register" element={<Auth mode="register" />} />
            <Route path="/clubs" element={<Clubs />} />
            <Route path="/calculator" element={<RevenueCalculator />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:id" element={<BlogPost />} />
            <Route path="/owner/blog" element={<Protected role="owner"><OwnerBlog /></Protected>} />
            <Route path="/clubs/:id" element={<ClubDetail />} />
            <Route path="/payment-return" element={<PaymentReturn />} />
            <Route path="/verify" element={<VerifyPage />} />
            <Route path="/privacy" element={<LegalPage kind="privacy" />} />
            <Route path="/terms" element={<LegalPage kind="terms" />} />
            <Route path="/dashboard" element={<Protected role="customer"><CustomerDashboard /></Protected>} />
            <Route path="/card" element={<Protected role="customer"><MembershipCard /></Protected>} />
            <Route path="/owner" element={<Protected role="owner"><OwnerDashboard /></Protected>} />
            <Route path="/admin" element={<Protected role="admin"><AdminDashboard /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
